import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/ko.ts
var add = "추가";
var remove = "제거";
var removeAll = "모두 제거";
var incomplete = "모든 값을 채워주세요";
var submit = "제출하기";
var noFiles = "선택된 파일이 없습니다";
var moveUp = "위로 이동";
var moveDown = "아래로 이동";
var isLoading = "로드 중...";
var loadMore = "더 불러오기";
var next = "다음";
var prev = "이전";
var addAllValues = "모든 값 추가";
var addSelectedValues = "선택한 값 추가";
var removeAllValues = "모든 값 제거";
var removeSelectedValues = "선택한 값 제거";
var chooseDate = "날짜 선택";
var changeDate = "날짜 변경";
var close = "닫기";
var open = "열기";
var accepted = function({
  name
}) {
  return `${name} 올바른 값을 선택 해주세요`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} 이후여야 합니다`;
  }
  return `${sentence(name)} 미래의 날짜여야합니다`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} 알파벳 문자만 포함할 수 있습니다`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} 문자와 숫자만 포함될 수 있습니다`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} 문자와 공백만 포함할 수 있습니다.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} 에는 알파벳 문자가 포함되어야 합니다.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} 에는 문자나 숫자가 포함되어야 합니다.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} 에는 문자나 공백이 포함되어야 합니다.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} 에는 기호를 포함해야 합니다.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} 는 대문자를 포함해야 합니다.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} 는 소문자를 포함해야 합니다.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} 에는 숫자가 포함되어야 합니다.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} 는 기호여야 합니다.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} 는 대문자만 포함할 수 있습니다.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} 는 소문자만 포함할 수 있습니다.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} 이전여야 합니다`;
  }
  return `${sentence(name)} 과거의 날짜여야합니다`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `잘못된 구성으로 제출할 수 없습니다`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} ${a}와 ${b} 사이여야 합니다`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} 일치하지 않습니다`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} 유효한 날짜가 아닙니다. ${args[0]}과 같은 형식을 사용해주세요`;
  }
  return "잘못된 구성으로 제출할 수 없습니다";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} ${date(args[0])}에서 ${date(args[1])} 사이여야 합니다`;
};
var email = "올바른 이메일 주소를 입력해주세요";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)}로 끝나지 않습니다`;
};
var is = function({
  name
}) {
  return `${sentence(name)} 허용되는 값이 아닙니다`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} 하나 이상의 문자여야 합니다`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} ${max2}자 이하여야 합니다`;
  }
  if (min2 === max2) {
    return `${sentence(name)} 는 ${max2} 자 길이여야 합니다.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} ${min2} 문자보다 크거나 같아야 합니다`;
  }
  return `${sentence(name)} ${min2}에서 ${max2}자 사이여야 합니다`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} 허용되는 값이 아닙니다`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${args[0]} ${name} 초과할 수 없습니다`;
  }
  return `${sentence(name)} ${args[0]}보다 작거나 같아야 합니다`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "파일 형식이 허용되지 않습니다";
  }
  return `${sentence(name)} ${args[0]} 유형이어야 합니다`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${args[0]} ${name}보다 작을 수 없습니다`;
  }
  return `${sentence(name)} ${args[0]} 이상이어야 합니다`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `${value}" 허용되지 않는 ${name}입니다`;
};
var number = function({
  name
}) {
  return `${sentence(name)} 숫자여야 합니다`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" 또는 ")}가 필요합니다.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} 필수 값입니다`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)}로 시작하지 않습니다`;
};
var url = function() {
  return `유효한 URL을 입력하십시오.`;
};
var invalidDate = "선택한 날짜가 잘못되었습니다.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var ko_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, ko_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=ko.mjs.map